import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/SignInView.vue')
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/SignUpView.vue')
    },
/*    {
      path: '/events',
      name: 'events',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/LoxEventView.vue')
    },*/
    {
      path: '/events/:page(\\d+)?',
      name: 'events',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/LoxEventView.vue')
    },
    {
      path: '/event/:id/show-bets/:page(\\d+)?',
      name: 'event-show-bets',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/CreateBetForLoxEventView.vue')
    },
    {
      path: '/event/:id',
      name: 'event',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/UpdateLoxEventView.vue'),

/*
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        //console.log(app.config.globalProperties.$resource.users().can())

        return { path: '/event/', query: { q: to.params.id } }
      },
*/

    },
    {
      path: '/create-event',
      name: 'create-event',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/CreateLoxEventView.vue')
    },
    {
      path: '/event/:event_id/item/:id',
      name: 'item',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/CreateUpdateBetView.vue')
    },
    {
      path: '/add-bet-to-event/:event_id',
      name: 'add-item-to-list',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/CreateUpdateBetView.vue')
    },

    {
      path: '/users/:page(\\d+)?',
      name: 'users',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/UsersView.vue')
    },
    {
      path: '/user/:id(\\d+)?',
      name: 'user',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/UserEditView.vue')
    },
    {
      path: '/create-user',
      name: 'create-user',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/UserEditView.vue')
    },
  ]
})

/*router.beforeEach((to, from, next) => {

  const app = inject('app');
  console.log(app.user.getToken())
  if (to.name !== 'login' && !true) {
    app.user.setPrevious(to.name)
    next({ name: 'login' })
  }  else next()
})*/
export default router
